import axios from "axios";
import { admission, mua, site, tabian } from "./config/api";

import { startLoading, stopLoading } from "./utils/loadingBus";

/**
 * Development only: rewrite absolute API hosts → path สัมพัทธ์
 * เพื่อให้ผ่าน CRA setupProxy (เลี่ยง CORS / ชี้ PHP ใน Docker)
 *
 * Production: ไม่แตะ URL — ใช้ค่าที่ bake จาก .env.production
 */
axios.interceptors.request.use((config) => {
  if (typeof config.url === "string" && process.env.NODE_ENV === "development") {
    const localAdmission = "/admission2017";
    const localMua = "/FrontEnd_Admission";
    const localTabian = "/FrontEnd_Tabian";

    config.url = config.url
      .replace(admission, localAdmission)
      .replace(mua, localMua)
      .replace(tabian, localTabian)
      .replace(site, "")
      .replace(/https?:\/\/admission\.kpru\.ac\.th\/admission2017/gi, localAdmission)
      .replace(/https?:\/\/admission\.kpru\.ac\.th/gi, "")
      .replace(/https?:\/\/mua\.kpru\.ac\.th\/FrontEnd_Admission/gi, localMua)
      .replace(/https?:\/\/mua\.kpru\.ac\.th\/FrontEnd_Tabian/gi, localTabian)
      .replace(/https?:\/\/git\.kpru\.ac\.th\/admission2017/gi, localAdmission)
      .replace(/https?:\/\/git\.kpru\.ac\.th\/FrontEnd_Admission/gi, localMua);
  }

  if (!config.skipLoading) {
    config.__loadingTracked = true;
    startLoading();
  }

  return config;
});

function endTrackedLoading(config) {
  if (config && config.__loadingTracked) {
    config.__loadingTracked = false;
    stopLoading();
  }
}

axios.interceptors.response.use(
  (response) => {
    endTrackedLoading(response.config);
    return response;
  },
  (error) => {
    endTrackedLoading(error.config);
    return Promise.reject(error);
  }
);
